<template>
  <el-breadcrumb class="app-breadcrumb" separator="/">
    <transition-group name="breadcrumb">
      <el-breadcrumb-item v-for="(item,index) in levelList" :key="item.path">
        <span v-if="item.redirect==='noredirect'||index==levelList.length-1" class="no-redirect">{{ item.meta.title }}</span>
        <a v-else @click.prevent="handleLink(item)">{{ item.meta.title }}</a>
      </el-breadcrumb-item>
      <el-breadcrumb-item v-for="(item,index) in detailList.concat([{name: '返回上级'}])" :key="index">
        <a @click.prevent="handleLinkDetail(item.path)">{{ item.name }}</a>
      </el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb>
</template>

<script>
import pathToRegexp from 'path-to-regexp'
import { getMatchInfo, getMatchGroup, getGroupTeam } from '@/api/match'
import { getUserById} from '../../api/user'

export default {
  data() {
    return {
      levelList: null,
      detailList: []
    }
  },
  watch: {
    $route() {
      this.getBreadcrumb()
    }
  },
  created() {
    this.getBreadcrumb()
  },
  methods: {
    getBreadcrumb() {
      let matched = this.$route.matched.filter(item => item.name)

      const first = matched[0]
      if (first && first.name !== 'dashboard') {
        matched = [{ path: '/dashboard', meta: { title: '概况' }}].concat(matched)
      }

      this.levelList = matched.filter(item => item.meta && item.meta.title && item.meta.breadcrumb !== false)
      this.detailList = []
      this.queryParams = this.$route.params
      if (this.queryParams.id) {
        getMatchInfo({id: this.queryParams.id}).then((resolve) => {
          if (resolve && resolve.data) {
            const data = resolve.data.match
            const obj = { id: this.queryParams.id, key: 'id', name: data.name, path: '/league/details/' + this.queryParams.id }
            this.detailList.push(obj)

            // gid
            if (this.queryParams.gid) {
              const params = { id: this.queryParams.gid }
              getMatchGroup(params).then((resolve) => {
                if (resolve && resolve.data) {
                  const data = resolve.data.group
                  const obj = { id: this.queryParams.gid, key: 'gid', name: data.name, path: '/league/'+this.queryParams.id+'/group/details?gid=' + this.queryParams.gid }
                  this.detailList.push(obj)

                  // tid
                  if (this.queryParams.tid) {
                    let params = {
                      groupId: this.queryParams.gid,
                      teamId: this.queryParams.tid
                    }
                    getGroupTeam(params).then((resolve) => {
                      if (resolve && resolve.data) {
                        const data = resolve.data.team
                        const obj = { id: this.queryParams.tid, key: 'tid', name: data.name, path: '/league/'+this.queryParams.id+'/group/'+this.queryParams.gid+'/team/' + this.queryParams.tid + '/players' }
                        this.detailList.push(obj)
                      }
                    })
                  } // tid
                }
              })
            } // gid
          }
        })
      }
      const queryfilter = this.$route.query;
      if (queryfilter.matchType == 0 || queryfilter.matchType) {
        let mtid = queryfilter.matchType;
        const name = mtid == 0 ? "标准比赛" : (mtid == 1 ? "小场地" : (mtid == 2 ? "国际" : (mtid == 3 ? "国家" : (mtid == 4 ? "市级" : "地区"))));
        const obj = { id: mtid, key: 'matchTypeId', name: name}
        this.detailList.push(obj)
      }
      if (this.queryParams.uId) {
        getUserById(this.queryParams.uId).then((resolve)=>{
          if(resolve && resolve.data) {
            const data = resolve.data.user
            const obj = { id: this.queryParams.uId, key: 'uId', name: data.trueName}
            this.detailList.push(obj)
          }
        })
      }
    },
    pathCompile(path) {
      // To solve this problem https://github.com/PanJiaChen/vue-element-admin/issues/561
      const { params } = this.$route
      var toPath = pathToRegexp.compile(path)
      return toPath(params)
    },
    handleLinkDetail(path) {
      this.$router.push({path, path})
    },
    handleLink(item) { // TODO hack parse router path
      let { redirect, path } = item
      if (redirect && redirect.indexOf(':id') > -1) {
        redirect = this.replacePath(redirect, 'id')
      }
      if (path.indexOf(':id') > -1) {
        path = this.replacePath(path, 'id')
      }
      if (redirect && redirect.indexOf(':gid') > -1) {
        redirect = this.replacePath(redirect, 'gid')
      }
      if (path.indexOf(':gid') > -1) {
        path = this.replacePath(path, 'gid')
      }
      if (redirect) {
        this.$router.push(redirect)
        return
      }
      this.$router.push(this.pathCompile(path))
    },
    replacePath(path, key) {
      const params = this.$route && this.$route.params
      const arr = path.split(':' + key + '(\\d+)')
      return arr[0] + params[key] + arr[1]
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .app-breadcrumb.el-breadcrumb {
    display: inline-block;
    font-size: 14px;
    line-height: 50px;
    margin-left: 10px;
    .no-redirect {
      color: #97a8be;
      cursor: text;
    }
  }
</style>
